// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__pAk9t","rotate":"Loader_rotate__C4+-E","path":"Loader_path__UEggN","dash":"Loader_dash__IF2Q9"};